export default "__VITE_ASSET__CyGNYNmg__"